export const BILLS_KEY = "Bills";

export interface DownloadBillArgsT {
  billId: string;
  billNumber: number;
  monthAndYear: string;
  token: string | undefined;
}
